import { computed, ref } from 'vue'

// Helper function to safely create matchMedia queries
function createMediaQuery(query) {
  if (typeof window !== 'undefined' && window.matchMedia) {
    return window.matchMedia(query)
  }
  // Return mock object for SSR/testing environments
  return { matches: false }
}

// GLOBAL DATA
const viewports = [
  { name: 'small', query: createMediaQuery(`(min-width: 0px)`) },
  { name: 'medium', query: createMediaQuery(`(min-width: 672px)`) },
  { name: 'large', query: createMediaQuery(`(min-width: 1056px)`) },
  { name: 'wide', query: createMediaQuery(`(min-width: 1312px)`) },
  { name: 'ultra', query: createMediaQuery(`(min-width: 1584px)`) },
  { name: 'max', query: createMediaQuery(`(min-width: 1920px)`) },
]

const smViewports = ['small', 'medium']
const currentViewport = ref(viewports.findLast(v => v.query.matches)?.name || 'medium')

// Only add event listener if window is available
if (typeof window !== 'undefined') {
  window.addEventListener('resize', () => {
    currentViewport.value = viewports.findLast(v => v.query.matches)?.name || 'medium'
  })
}

export default function useBrowser() {
  const isSmallOnlyViewport = computed(() => {
    return currentViewport.value === 'small'
  })

  const isSMViewport = computed(() => {
    return smViewports.includes(currentViewport.value)
  })

  function isSafari() {
    return /^((?!chrome|android).)*safari/i.test(navigator.userAgent)
  }

  return {
    viewports,
    currentViewport,

    // COMPUTED
    isSMViewport,
    isSmallOnlyViewport,

    // METHODS
    isSafari,
  }
}
